<template>
  <el-dialog
      :visible.sync="dialogVisible"
      width="30%"
      :show-close="false"
  >
    <div class="custom-dialog-header" slot="title">
      <span>销户退租</span>
      <i class="el-icon-close custom-close-button" @click="handleCancel"></i>
    </div>
    <el-divider class="line"/>
    <div class="passInfo" v-show="isShow === 1">
      <div class="passInfo-warn">
        请与租户线下确认好电费余额的退补，<span style="color: #fd4339">此操作不可逆，请谨慎操作。</span>清账销户成功后，电费余额清0，房间断电，变为未开户状态。并自动生成退租单，多余电费自动退回租户账户。
      </div>
      请输入密码， 确认此操作
    </div>
    <div class="passInfo" v-show="isShow === 5">
      <div class="passInfo-warn">
        密码输入成功！请再次确认是否继续执行该操作，<span style="color: #fd4339">此操作不可逆，请谨慎操作。</span>
      </div>
    </div>
    <div class="passInput" v-show="isShow === 1">
      <div class="input-box row-center">
        <div class="code-item" :class="codeValue.length == 0 && inputFocus ? 'code-item-active' : ''">
          {{ codeValue[0] | filterVal }}
        </div>
        <div class="code-item" :class="codeValue.length == 1 && inputFocus ? 'code-item-active' : ''">
          {{ codeValue[1]| filterVal }}
        </div>
        <div class="code-item" :class="codeValue.length == 2 && inputFocus ? 'code-item-active' : ''">
          {{ codeValue[2]| filterVal }}
        </div>
        <div class="code-item" :class="codeValue.length == 3 && inputFocus ? 'code-item-active' : ''">
          {{ codeValue[3]| filterVal }}
        </div>
        <el-input class="input-code"
                  :value="codeValue"
                  :maxlength="4"
                  @blur="codeInputBlur"
                  @focus="codeInputFocus"
                  @input="codeInputChange">
        </el-input>
      </div>
    </div>
    <span slot="footer" class="dialog-footer" v-show="isShow === 1">
        <el-button style="width: 20%; margin-right: 30rem" @click="handleCancel" round>取 消</el-button>
        <el-button style="width: 20%" type="primary" @click="handleOk('one')" round>确 定</el-button>
      <div style="width: 50rem; height: 80rem"></div>
    </span>
    <span slot="footer" class="dialog-footer" v-show="isShow === 5">
        <el-button style="width: 20%" type="primary" @click="handleOk('twice')" round>再次确认</el-button>
      <div style="width: 50rem; height: 80rem"></div>
    </span>
    <!--    不欠费的情况下，操作成功页面-->
    <div class="success">
      <img class="success-img" src="@/assets/img/success1.png" alt="" v-show="isShow === 2 || isShow === 4">
      <div class="success-text1" v-show="isShow === 2 || isShow === 4">操作成功</div>
      <div class="success-text2" v-show="isShow === 2">
        稍后刷新页面查看，已为您自动下载退租单<br/>
        结余电费共 <span style="color: #2b97f1">¥{{ tenement.cost }}</span>，请与租户确认费用明细
      </div>
      <div class="success-text2" v-show="isShow === 4">
        稍后刷新页面查看，已为您自动下载退租单<br/>
        租户应补电费 <span style="color: #2b97f1">¥{{ String(tenement.cost).substr(1) }}</span>，请与租户确认缴费明细
      </div>
      <div class="success-text3" v-show="isShow === 3">
        当前租户应补缴电费 <span style="color: #2b97f1">¥{{ String(tenement.cost).substr(1) }}</span>，请下载退租单（系统为您自动下载），与租户确认缴费明细后，再进行退租。
      </div>
      <div slot="footer">
        <el-button type="primary" size="mini" style="width: 120rem"
                   v-show="isShow === 2 || isShow === 3 || isShow === 4" @click="download">
          <a href="javascript:;"
             style="text-decoration: none;color: #FFFFFF"
          >下载退租单</a>
        </el-button>
        <el-button type="primary" size="mini" style="width: 120rem" @click="handleCancel"
                   v-show="isShow === 2 || isShow === 4">退出
        </el-button>
        <el-button type="primary" size="mini" style="width: 120rem" @click="handleGoOn" v-show="isShow === 3">继续退租
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {
  GET_V3_Cost_Room_Valid_Password,
  PUT_V3_Cost_Enterprise_Renting_Out
} from '@/api/billing.js'
import {api} from "../../../../config";
import store from "../../../store/index";

export default {
  name: "dialogManage",
  props: ['getInit'],
  data() {
    return {
      dialogVisible: false,
      codeValue: '',
      inputFocus: false,
      isShow: 1,
      // 租户数据
      tenement: {}
    }
  },
  filters: {
    filterVal(value) {
      if (value) {
        return '*';
      }
    }
  },
  methods: {
    download() {
      const downloadLink = document.createElement('a');
      const apiUrl = `${api}v3/cost/export/enterprise/renting?projectId=${store.getters.projectId}&enterpriseId=${this.tenement.enterpriseId}`;

      fetch(apiUrl)
          .then(response => response.blob())
          .then(blob => {
            const objectUrl = URL.createObjectURL(blob);
            downloadLink.href = objectUrl;
            downloadLink.download = '退租单.xlsx';
            downloadLink.click();
            URL.revokeObjectURL(objectUrl);
          })
          .catch(error => {
            console.error(error);
          });
    },

    handleCancel() {
      this.dialogVisible = false
    },

    // 密码验证
    async handlePass(val) {
      const {data} = await GET_V3_Cost_Room_Valid_Password({
        password: val
      })
      return data
    },

    // 确认销户退租
    async handleRenterOut() {
      if (this.tenement.cost < 0) {
        // 欠费，提醒房东需要补缴电费后再选择是否继续退租 isShow = 3
        this.isShow = 3
        // 这里要自动下载退租单
        this.download()
      } else {
        const {data} = await PUT_V3_Cost_Enterprise_Renting_Out(this.tenement.enterpriseId)
        // console.log('销户退租 === ', data.code)
        if (data.code == 200) {
          this.$message.success('租户销户退租成功！')
          this.$emit('getInit')
          this.download()
          this.isShow = 2
        } else {
          this.$message.error('租户销户退租失败，请重试！')
        }
      }
    },

    async handleOk(type) {
      switch (type) {
        case 'one':
          if (this.codeValue.length === 0) {
            this.$message({
              message: '请输入密码！',
              type: 'warning'
            });
          } else if (this.codeValue.length < 4 && this.codeValue.length > 0) {
            this.$message({
              message: '请输入完整密码！',
              type: 'warning'
            });
          } else {
            const data = await this.handlePass(this.codeValue)
            // console.log(data)
            if (data.data == true) {
              // TODO 这里isShow == 5 是表示 密码输入成功显示二次确认页面
              this.isShow = 5
            } else {
              this.codeValue = ''
              this.$message.error('密码输入错误，请重新输入！')
            }
            // TODO 这里调接口进行销户退租，查看返回结果
            // TODO 若还有剩余电费，自动退还，提供退租单， isShow = 2
            // this.isShow = 2
            // TODO 若欠费，需要弹出补缴窗口供选择 isShow = 3
            // this.isShow = 3
          }
          ;
          break
        case 'twice':
          await this.handleRenterOut()
          break
        default:
          return
      }
    },

    // 继续退租
    async handleGoOn() {
      const {data} = await PUT_V3_Cost_Enterprise_Renting_Out(this.tenement.enterpriseId)
      // console.log('销户退租 === ', data.code)
      if (data.code == 200) {
        this.$message.success('租户销户退租成功！')
        // 若欠费，二次选择继续退租， 此处需调用接口，接口调用成功赋值 isShow = 4
        this.isShow = 4
      } else {
        this.$message.error('租户销户退租失败，请重试！')
      }
    },

    // 验证码输入框失去焦点
    codeInputBlur() {
      this.inputFocus = false;
    },

    // 验证码输入框获取到焦点
    codeInputFocus() {
      this.inputFocus = true;
    },

    // 验证码输入框
    codeInputChange(e) {
      if (e) {
        // 判断输入内容是否为数字
        if ((/^\+?[0-9][0-9]*$/).test(e)) {
          this.codeValue = e;
        }
      } else {
        this.codeValue = '';
      }
    },
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.codeValue = ''
        this.isShow = 1
      }
    }

  }
}
</script>

<style scoped lang="less">
.custom-dialog-header {
  width: 93%;
  padding: 0;
  font-size: 24rem;
  position: absolute;
  top: 16rem;
  left: 24rem;
  //background-color: pink;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .custom-close-button {
    background-color: transparent;
    border: none;
    cursor: pointer;
    //font-size: 24rem;

    &:hover {
      color: #409eff;
    }
  }
}

.line {
  position: absolute;
  left: 0;
  top: 35rem;
}

.passInfo {
  text-align: center;
  color: #666;
  font-size: 18rem;
  margin-top: 20rem;

  .passInfo-warn {
    width: 93%;
    color: #333;
    margin: 0 auto 20rem;
  }
}

.passInput {
  display: flex;
  justify-content: space-around;

  .passInput-item {
    width: 12%;
    border-bottom: 1px solid #666;
    text-align: center;
  }

  /deep/ .el-input {
    width: 100%;
  }

  /deep/ .el-input__inner {
    border: none;
  }

  .input-box {
    margin-top: 10px;
    position: relative;
  }

  .input-code {
    position: absolute;
    left: 0;
    opacity: 0;
  }

  .code-item {
    width: 75px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    border-bottom: 2px solid #999999;
    margin: 0 20px;
    display: inline-block;
  }

  .code-item-active {
    border-color: #0D94FF;
    //border-bottom: 2px solid #0D94FF;
  }

  // 隐藏input
  .input-box {
    .el-input__inner {
      width: 362px;
      height: 50px;
      background-color: transparent;
      border: none;
      color: transparent;
    }
  }
}

.success {
  text-align: center;
  padding: 0 50rem;

  .success-img {
    width: 65rem;
    height: 65rem;
    margin-bottom: 10rem;
  }

  .success-text1 {
    font-size: 20rem;
  }

  .success-text2 {
    font-size: 15rem;
    color: #999;
    margin-bottom: 20rem;
  }

  .success-text3 {
    text-align: left;
    margin-top: 50rem;
    margin-bottom: 80rem;
  }
}

</style>